var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAscending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 3.75C7.75 3.33579 7.41421 3 7 3C6.58579 3 6.25 3.33579 6.25 3.75V18.4393L4.53033 16.7197C4.23744 16.4268 3.76256 16.4268 3.46967 16.7197C3.17678 17.0126 3.17678 17.4874 3.46967 17.7803L6.46967 20.7803C6.76256 21.0732 7.23744 21.0732 7.53033 20.7803L10.5303 17.7803C10.8232 17.4874 10.8232 17.0126 10.5303 16.7197C10.2374 16.4268 9.76256 16.4268 9.46967 16.7197L7.75 18.4393V3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1753 3.42363C18.0501 3.16475 17.788 3.00019 17.5005 3C17.213 2.99981 16.9506 3.16402 16.8252 3.42273L13.6729 9.92273C13.4921 10.2954 13.6477 10.7441 14.0204 10.9248C14.3931 11.1056 14.8418 10.95 15.0225 10.5773L16.0299 8.5H18.9628L19.9663 10.5764C20.1466 10.9493 20.595 11.1055 20.968 10.9253C21.3409 10.745 21.4971 10.2966 21.3169 9.92363L18.1753 3.42363ZM17.4988 5.47111L18.2378 7H16.7574L17.4988 5.47111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13C14.3358 13 14 13.3358 14 13.75C14 14.1642 14.3358 14.5 14.75 14.5H18.6329L14.1775 19.7655C13.9888 19.9885 13.9467 20.3006 14.0696 20.5656C14.1925 20.8305 14.458 21 14.75 21H20.25C20.6642 21 21 20.6642 21 20.25C21 19.8358 20.6642 19.5 20.25 19.5H16.3671L20.8225 14.2345C21.0112 14.0115 21.0533 13.6994 20.9304 13.4344C20.8075 13.1695 20.542 13 20.25 13H14.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAscending);
export default __webpack_public_path__ + "static/media/filter-ascending.86806e05b83001162db97ac4927acd50.svg";
export { ForwardRef as ReactComponent };